interface JsonLdProps {
  data: Record<string, unknown>;
}

export function JsonLd({ data }: JsonLdProps) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}

export function getOrganizationSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '桃花视频',
    url: '',
    logo: '',
    description: '桃花视频提供91视频、久久视频、91在线视频等热门影视资源，免费在线观看高清电视剧全集和电影大全，流畅不缓冲，最新内容持续更新。',
    foundingDate: '2018',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '400-888-6666',
      contactType: 'customer service',
      email: 'contact@taohuavideo.com',
      availableLanguage: ['Chinese'],
    },
    sameAs: [
      '#',
      '#',
    ],
  };
}

export function getWebSiteSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '桃花视频',
    url: '',
    description: '桃花视频提供91视频、久久视频、91在线视频等热门影视资源，免费在线观看高清电视剧全集和电影大全。',
    potentialAction: {
      '@type': 'SearchAction',
      target: { '@type': 'EntryPoint', urlTemplate: '/search?q={search_term_string}' },
      'query-input': 'required name=search_term_string',
    },
  };
}

export function getWebPageSchema(name: string, description: string, canonicalUrl: string) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name,
    description,
    url: canonicalUrl,
    isPartOf: {
      '@type': 'WebSite',
      name: '桃花视频',
      url: '',
    },
  };
}

export function getBreadcrumbSchema(items: Array<{ name: string; item?: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      ...(item.item ? { item: item.item } : {}),
    })),
  };
}

export function getArticleSchema(video: {
  title: string;
  description: string;
  thumbnail: string;
  releaseDate: string;
  url: string;
  category: string;
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: video.title,
    description: video.description,
    image: video.thumbnail,
    datePublished: video.releaseDate,
    url: video.url,
    articleSection: video.category,
    author: {
      '@type': 'Organization',
      name: '桃花视频',
    },
    publisher: {
      '@type': 'Organization',
      name: '桃花视频',
    },
  };
}

export function getFAQSchema(faqs: Array<{ question: string; answer: string }>) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };
}